/* tslint:disable:indent */
// Angular
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns the first n chars of a string
 */
@Pipe({
	name: 'maxCharacters'
})
export class MaxCharactersPipe implements PipeTransform {

	/**
	 * Transform
	 *
	 * @param value: any
	 * @param args: any
	 */
	transform(value: string, maxLength: number): string {
		if (value ) {
			if (value.length <= maxLength) {
				return value;
			} else {
				return (value.substring(0, (maxLength + 1 - 3))) + '...';
			}
		}else{
			return '';
		}
	}
}
